import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import { FormControl, Row, Col } from 'react-bootstrap';

export default class TimePicker extends React.Component {
  constructor(props) {
    super(props);
  }
  handleChange(event) {
    const time = moment(event.target.value, 'hh:mma').utc().toDate();
    this.props.onChange(time);
  }

  renderTimestamps(addEmptyTimestamp = false) {
    const fifteenMinutesInterval = 24 * 4;
    const timestamps = _.range(fifteenMinutesInterval).map((interval) => {
      const timestamp = moment().startOf('day').add(Math.abs(interval) * 15, 'minutes').format('hh:mm a');
      return (
        <option key={timestamp} value={timestamp}>{timestamp}</option>
      );
    });
    if (addEmptyTimestamp) {
      timestamps.unshift((<option key={null} value={null} />));
    }
    return timestamps;
  }

  render() {
    const time = this.props.time ? moment(this.props.time).format('hh:mm a') : null;
    return (
      <Row>
        <Col xs={12}>
          <FormControl
            value={time}
            onChange={e => this.handleChange(e)}
            componentClass="select"
            placeholder="select"
            bsSize={this.props.isContainer ? "small" : "default"}
          >
            {this.renderTimestamps(this.props.addEmptyTimestamp)}
          </FormControl>
        </Col>
      </Row>
    );
  }
}

TimePicker.propTypes = {
  time: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  addEmptyTimestamp: PropTypes.boolean,
};
